require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-alpha-ng.json") })
        }
      }, "path---blog-author-alpha-ng");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-alpha-ng!./.cache/json/blog-author-alpha-ng.json
// module id = 601
// module chunks = 231608221292675